import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { ExternalAppApi, UpdateExternalAppDto } from '../../../api-client';
import { getApiConfiguration } from '../../../common';

type UseUpdateExternalApp = (
  options?: Omit<
    UseMutationOptions<AxiosResponse<void>, ErrorResponse, UpdateExternalAppsMutationArgs>,
    'mutationFn'
  >,
) => UseMutationResult<AxiosResponse<void>, ErrorResponse, UpdateExternalAppsMutationArgs>;

export type UpdateExternalAppsMutationArgs = {
  id: string;
  updateExternalAppDto: UpdateExternalAppDto;
};

export const useUpdateExternalApp: UseUpdateExternalApp = (options) => {
  const customRolesApi = new ExternalAppApi(getApiConfiguration());
  const tenantId = localStorage.getItem('tenantId') as string;

  return useMutation(
    (args: UpdateExternalAppsMutationArgs) =>
      customRolesApi.updateExternalApp(args.id, tenantId, args.updateExternalAppDto),
    options,
  );
};
